interface Choice {
  label: string;
  description?: string;
}

interface MultipleChoiceCardProps {
  choices: Choice[];
  onSelect: (label: string) => void;
  disabled?: boolean;
}

export default function MultipleChoiceCard({ choices, onSelect, disabled }: MultipleChoiceCardProps) {
  return (
    <div className="flex flex-col gap-2 px-4 py-2">
      {choices.map((choice) => (
        <button
          key={choice.label}
          onClick={() => onSelect(choice.label)}
          disabled={disabled}
          className="text-left px-4 py-3 bg-white border border-gray-200 rounded-lg hover:border-blue-400 hover:bg-blue-50 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <p className="text-sm font-medium text-gray-800">{choice.label}</p>
          {choice.description && (
            <p className="text-xs text-gray-500 mt-0.5">{choice.description}</p>
          )}
        </button>
      ))}
    </div>
  );
}
